<template>
  <div :class="['select', {'select--active': isActive}]">
    <input
      :class="['select__input', {'select__input--active': isActive}]"
      type="text"
      @click="isActive = !isActive"
      :id="id"
      :placeholder="label"
      :value="value"
      :required="required"
      :readonly="true"
    />
    <div v-show="isActive" class="select__options">
      <div class="select__wrapper">
        <div
          v-for="(option, index) in options"
          :class="['select__option', {'select__option--selected': value === option}]"
          :key="index"
					:tabindex="index + 1"
          @click="updateValue(option)"
        >
					{{ option }}
				</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false
    };
  },
  props: {
    id: {
      type: String
    },
    label: {
      type: String
    },
    value: {
      type: String
    },
    options: {
			type: Array,
			required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
      this.isActive = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.select {
  position: relative;
	cursor: pointer;
  &__options {
    position: absolute;
    background: white;
    border: 2px solid #e1e1e1;
    box-sizing: border-box;
    border-top: 0;
    border-radius: 0 0 25px 25px;
    width: 100%;
    z-index: 10;
    padding: 0 0 15px 0;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.16);
  }
  &__wrapper {
    overflow: auto;
    max-height: 75vh;
  }
  &__input {
    cursor: pointer;
    position: relative;
    z-index: 11;
    &--active {
      border-radius: 25px 25px 0 0 !important;
			border: 2px solid #e1e1e1 !important;
    }
  }

  &__option {
    padding: 5px 15px;
    cursor: pointer;
    text-align: left;
    transition: all 200ms;
    &--selected {
      background: #85b904;
      color: white;
    }
    &:hover:not(.select__option--selected) {
      background: whitesmoke;
      color: #4a4949;
    }
  }
  &:after {
    border: 7px solid transparent;
    border-bottom: 10px solid #c5c5c5;
    content: " ";
    position: absolute;
    right: 10px;
    top: 8px;
    z-index: 12;
    transform: rotate(180deg);
    transform-origin: 7px 12px;
	}
	&--active:after {
		transform: none
	}
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: silver;
  &:hover {
    background: #85b904;
  }
}

::-webkit-scrollbar-track {
  background: whitesmoke;
}
</style>